<template>
    <div class="d-flex main-sidebar-shell" >
        <div :class="['sidebar-wrapper', { open: isOpen }]">
            <!-- Menu -->
            <ul class="sidebar-icons">
                <button v-if="hasBubble && !bubbleOpen" class="toggle-btn" @click="toggleOpen">
                    <img :src="menuIcon" alt="toggle" />
                </button>
                <div v-if="hasBubble && !bubbleOpen" class="menu-divider"></div>
                
                <li v-for="item in menuItems.slice(0, menuItems.length - 1)" :key="item.name">
                    <div v-if="item.name === 'Create Project'" class="menu-item" @mouseenter="hoverItem = item.name"
                        @mouseleave="hoverItem = null" @click="openCreateProjectFromSidebar">
                        <span class="bg-full"></span>
                        <span class="menu-content">
                            <span class="icon-wrapper">
                                <span class="icon-bg"></span>

                                <MyToolTip :label="item.name" placement="right">
                                    <img :src="getIcon(item)" class="menu-icon" />
                                </MyToolTip>
                            </span>
                            <span v-if="isOpen" class="menu-label">{{ item.name }}</span>
                        </span>
                    </div>
                    <!-- <div v-else-if="item.name === 'Take Note'" class="menu-item" @mouseenter="hoverItem = item.name"
                    @mouseleave="hoverItem = null" @click="openTakeNoteFromSidebar">
                    <span class="bg-full"></span>
                    <span class="menu-content">
                        <span class="icon-wrapper">
                            <span class="icon-bg"></span>

                            <MyToolTip :label="item.name" placement="right">
                                <img :src="getIcon(item)" class="menu-icon" />
                            </MyToolTip>
                        </span>
                        <span v-if="isOpen" class="menu-label">{{ item.name }}</span>
                    </span>
                </div> -->

                    <router-link v-else :to="item.to" :class="['menu-item', { active: isActive(item), open: isOpen }]"
                        @mouseenter="hoverItem = item.name" @mouseleave="hoverItem = null">
                        <span class="bg-full"></span>
                        <span class="menu-content">
                            <span class="icon-wrapper">
                                <span class="icon-bg"></span>

                                <MyToolTip :label="item.name" placement="right">
                                    <img :src="getIcon(item)" class="menu-icon" />
                                    <span v-if="totalMainCounts && item.name == 'Message'"
                                        class="notification-tick blinking"></span>
                                    <span v-if="item.name === 'E-Office' && hasPendingEofficeActions"
                                        class="eoffice-action-dot" aria-label="Có công việc E-Office cần xử lý"></span>

                                </MyToolTip>
                            </span>
                            <span v-if="isOpen" class="menu-label">{{ item.name }}</span>
                        </span>

                    </router-link>
                </li>
            </ul>

            <ul class="bottom-menu">
                <li v-for="item in menuItems.slice(-1)" :key="item.name">
                    <div v-if="item.name === 'Logout'" class="menu-item" @mouseenter="hoverItem = item.name"
                        @mouseleave="hoverItem = null" @click="logout()" style="cursor: pointer">
                        <span class="bg-full"></span>
                        <span class="menu-content">
                            <span class="icon-wrapper">
                                <span class="icon-bg"></span>

                                <MyToolTip :label="item.name" placement="right">
                                    <img :src="getIcon(item)" class="menu-icon" />
                                </MyToolTip>
                            </span>
                            <span v-if="isOpen" class="menu-label">{{ item.name }}</span>
                        </span>
                    </div>

                    <!-- các item còn lại vẫn là router-link -->
                    <router-link v-else :to="item.to" class="menu-item">
                        <span class="bg-full"></span>
                        <span class="menu-content">
                            <span class="icon-wrapper">
                                <span class="icon-bg"></span>
                                <MyToolTip :label="item.name" placement="right">
                                    <img :src="getIcon(item)" class="menu-icon" />
                                </MyToolTip>
                            </span>
                            <span v-if="isOpen" class="menu-label">{{ item.name }}</span>
                        </span>
                    </router-link>
                </li>
            </ul>

        </div>
        <div v-if="bubbleOpen" class="expand-bubble" @click.self="closeBubble">
            <noteBubble v-if="currentBubble === 'notes'" @close="closeBubble" />
            <documentBubble v-if="currentBubble === 'documents'" @close="closeBubble" />
            <projectBubble
                v-if="currentBubble === 'project'"
                @createProject="openCreateProjectFromSidebar"
                @overview="openProjectOverview"
                @close="closeBubble"
            />
        </div>
    </div>
</template>


<script setup>
import { useAuth } from "@/services";
import MyToolTip from "@/components/molecules/ToolTip/MyToolTip.vue";
import noteBubble from "@/components/organisms/NoteBubble/noteBubble.vue";
import documentBubble from "@/components/organisms/DocumentBubble/documentBubble.vue";
import projectBubble from "@/components/organisms/ProjectBubble/projectBubble.vue";
// import { inject } from 'vue'
import { ref, computed, watch, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from "vuex";
import { apiRequest } from '@/services'
import { workitRequest } from '@/services/workit'
import { countPendingEofficeActions } from '@/utils/eofficeWorkbench.cjs'
import { useCustomComposable } from '@/composable'
const {
    EOFFICE_PERMISSION_PATHS,
    hasEofficeAccess,
} = require('@/utils/eofficePermissions.cjs')
// import ToolTip from "@/components/molecules/ToolTip/ToolTip.vue";

const isOpen = ref(false)
const menuIcon = require('@/assets/images/svg/double_arrow_right.svg')
const store = useStore();
const { getters } = store;
const { checkPermission } = useCustomComposable();

const myCounts = computed(() => getters["users/myCounts"]?.data || {})
const { logOut } = useAuth();
const logout = () => {
    logOut({ islogOut: true });
}

const route = useRoute()
const router = useRouter()
const currentUser = computed(() => getters["users/currentUser"])
const hasPendingEofficeActions = computed(() => getters["digitalOffice/hasPendingActions"])
const notes = ref([])
const BUBBLE_OPEN_STORAGE_KEY = "kompact:main-sidebar:bubble-open"
const showBubble = ref(localStorage.getItem(BUBBLE_OPEN_STORAGE_KEY) === "true")
const bubbleConfig = {
    notes: 'notes',
    documents: 'documents',
    Projects: 'project',
    Project: 'project',
    ProjectSprint: 'project',
    ProjectFolder: 'project',
    ProjectSprintTask: 'project',
    ProjectFolderSprint: 'project',
    ProjectFolderSprintTask: 'project',
    ProjectOverview: 'project',
}

const currentBubble = computed(() => bubbleConfig[route.name] || null)

const hasBubble = computed(() => Boolean(currentBubble.value))
const bubbleOpen = computed(() => showBubble.value && currentBubble.value)
// const filteredNotes = computed(() => notes.value.filter(note => {
//     const isMine = note.userId === currentUser.value?._id
//     const isShared = note.sharedWith && note.sharedWith.length
//     return selectedCategory.value === 'all' ||
//         (selectedCategory.value === 'mine' && isMine) ||
//         (selectedCategory.value === 'shared' && isShared)
// }))

// const routerPath = computed(() => route.path)
const openCreateProjectFromSidebar = () => {
    if (!route.path.includes('/project')) {
        router.push({ path: `/${companyId.value}/project`, query: { openCreate: true } })
    } else {
        window.dispatchEvent(new CustomEvent('openCreateProject'))
    }
}

const openProjectOverview = () => {
    router.push({ name: 'ProjectOverview', params: { cid: route.params.cid } })
}


function toggleOpen() {
    // isOpen.value = !isOpen.value
    showBubble.value = true
}

function closeBubble() {
    showBubble.value = false
}

async function fetchNotes(userId) {
    if (!userId) return
    try {
        const res = await apiRequest('get', `/api/v1/notes?userId=${userId}`)
        notes.value = res?.data?.data || []
    } catch (err) {
        console.error('Fetch notes error:', err)
    }
}

watch(() => route.name, (name) => {
    if (name === 'notes') {
        if (currentUser.value?._id) fetchNotes(currentUser.value._id)
        return
    }
    // showBubble.value = false
})

watch(showBubble, (isOpen) => {
    localStorage.setItem(BUBBLE_OPEN_STORAGE_KEY, isOpen ? "true" : "false")
})

watch(() => currentUser.value?._id, (userId) => {
    if (route.name === 'notes' && userId) {
        fetchNotes(userId)
    }
})

onMounted(() => {
    if (route.name === 'notes' && currentUser.value?._id) {
        fetchNotes(currentUser.value._id)
    }
    if (canAccessEoffice.value) refreshEofficeActions()
})

async function refreshEofficeActions() {
    const [supplyResult, purchaseResult, ticketResult] = await Promise.allSettled([
        workitRequest('get', '/api/supply-proposals/summary'),
        workitRequest('get', '/api/purchase-requests/summary'),
        Promise.all([
            workitRequest('get', '/api/tickets/masters'),
            workitRequest('get', '/api/tickets'),
        ]),
    ])

    let ticketMasters = {}
    let tickets = []
    if (ticketResult.status === 'fulfilled') {
        const [mastersResponse, ticketsResponse] = ticketResult.value
        ticketMasters = mastersResponse?.data?.data || {}
        tickets = ticketsResponse?.data?.data?.items || []
    }
    const counts = countPendingEofficeActions({
        supplyResult: supplyResult.status === 'fulfilled' ? supplyResult.value : null,
        purchaseResult: purchaseResult.status === 'fulfilled' ? purchaseResult.value : null,
        ticketMasters,
        tickets,
    })
    store.commit('digitalOffice/setWorkbenchCounts', counts)
}

const companyId = computed(() => route.params.cid || route.params.companyId || 'default')
watch(companyId, refreshEofficeActions)

// Icon toggle
// const menuIcon = require('../../../assets/images/menu/expand.png')
// const closeIcon = require('../../../assets/images/menu/expand.png')
import HomeIcon from '../../../assets/images/menu/home.svg'
import HomeActiveIcon from '../../../assets/images/menu/home-active.png'
import ChatIcon from '../../../assets/images/menu/chat.svg'
import ChatActiveIcon from '../../../assets/images/menu/chat-active.png'
import ProjectIcon from '../../../assets/images/menu/project.svg'
import DocumentIcon from '../../../assets/images/menu/document.svg'
import DocumentActiveIcon from '../../../assets/images/menu/document_active.svg'
import ProjectActiveIcon from '../../../assets/images/menu/project-active.svg'
import PersonalTaskIcon from '../../../assets/images/menu/personal-task.svg'
import PersonalTaskActiveIcon from '../../../assets/images/menu/personal-task-active.svg'
// import MoreIcon from '../../../assets/images/menu/more.png'
// import CreateIcon from '../../../assets/images/menu/create-project.png'
import NoteActive from '../../../assets/images/menu/note-active.svg'
import LogoutIcon from '../../../assets/images/menu/logout.svg'
// import DigitalOfficeIcon from '../../../assets/images/menu/three-squares-normal.svg'
// import DigitalOfficeActiveIcon from '../../../assets/images/menu/three-squares-active.svg'
const takeNoteIcon = require("@/assets/images/menu/note.svg");

const eofficePermissionValues = computed(() => {
    const rules = getters['settings/rules'] || {}
    if (!rules.eoffice) return {}
    if (checkPermission('eoffice') === null) {
        return Object.fromEntries(Object.values(EOFFICE_PERMISSION_PATHS).map((path) => [path, null]))
    }
    return Object.fromEntries(Object.values(EOFFICE_PERMISSION_PATHS).map((path) => {
        const childKey = path.split('.')[1]
        return [path, rules.eoffice?.[childKey] ? checkPermission(path) : undefined]
    }))
})
const canAccessEoffice = computed(() => hasEofficeAccess(eofficePermissionValues.value))

const menuItems = computed(() => [
    { name: 'Dashboard', icon: HomeIcon, activeIcon: HomeActiveIcon, to: { path: `/${companyId.value}` } },
    { name: 'Message', icon: ChatIcon, activeIcon: ChatActiveIcon, to: { path: `/${companyId.value}/chat` } },
    { name: 'Projects', icon: ProjectIcon, activeIcon: ProjectActiveIcon, to: { path: `/${companyId.value}/project` } },
    { name: 'Personal Task', icon: PersonalTaskIcon, activeIcon: PersonalTaskActiveIcon, to: { path: `/${companyId.value}/personal-task` } },
    { name: 'Documents', icon: DocumentIcon, activeIcon: DocumentActiveIcon, to: { path: `/${companyId.value}/document` } },
    { name: 'Take Note', icon: takeNoteIcon, activeIcon: NoteActive, to: { path: `/${companyId.value}/note` } },
    // { name: 'E-Office', icon: DigitalOfficeIcon, activeIcon: DigitalOfficeActiveIcon, to: { path: `/${companyId.value}/digital-office` } },
    // { name: 'More', icon: MoreIcon, to: { path: `/${companyId.value}/more` } },
    // { name: 'Create Project', icon: CreateIcon },
    { name: 'Logout', icon: LogoutIcon },
].filter((item) => item.name !== 'E-Office' || canAccessEoffice.value));
const isActive = (item) => {
    if (!item.to) return false;
    if (item.name === 'Message') return ['chats', 'chat_project', 'chat_project_channel', 'chat_group'].includes(route.name);
    if (item.name === 'E-Office') return ['DigitalOfficeHome', 'DigitalOfficeApps', 'EmployeeDirectory', 'WeeklySchedules', 'DigitalProcessHome', 'SharedLibrary', 'SharedLibraryAdmin', 'SharedLibraryCatalog', 'SharedLibraryFolder', 'CompanyNews', 'DigitalSignatureTemplates', 'PdfSignatureEditor', 'Tickets', 'TicketCategories', 'PaymentRequests', 'AdvanceRequests', 'BusinessTrips', 'RewardProposals', 'TrainingRequests', 'QualificationSupplements', 'EmployeeInfoChanges', 'DisciplinaryProposals', 'ResignationRequests', 'LeaveRequests', 'OvertimeRequests', 'LateEarlyRequests', 'MissingAttendanceRequests', 'RecruitmentRequests', 'MeetingRooms', 'BusinessCars', 'OfficeSupplies', 'OfficeSupplyCatalog', 'PurchaseProcessHome', 'SupplyProposals', 'SupplyConfiguration', 'SupplyWorkflows', 'PurchaseRequests', 'PurchaseOrders', 'PurchasePrices'].includes(route.name);
    if (item.to.path === `/${companyId.value}`) return route.path === `/${companyId.value}`;
    return route.path.startsWith(item.to.path);
}
watch(() => route.name, () => {
    const eofficeItem = menuItems.value.find((item) => item.name === 'E-Office')
    if (eofficeItem && isActive(eofficeItem)) refreshEofficeActions()
})
watch(canAccessEoffice, (allowed) => {
    if (allowed) refreshEofficeActions()
})
// const toggleUserNote = inject('toggleUserNote')

// const openTakeNoteFromSidebar = () => {
//     if (!toggleUserNote) {
//         return
//     }
//     toggleUserNote(true)
// }
const hoverItem = ref(null)

const getIcon = (item) => {
    return (isActive(item) || hoverItem.value === item.name) && item.activeIcon
        ? item.activeIcon
        : item.icon
}
function processSprint(pid) {
    let total = 0;
    const keys = Object.keys(myCounts.value || {}).filter((x) => x.includes(`task_${pid}`));

    keys.forEach((key) => {
        if (myCounts.value?.[key]) {
            total += myCounts.value?.[key] || 0;
        }
    })
    const groupKeys = Object.keys(myCounts.value || {}).filter((x) => x.includes(`groupChat_${pid}`));
    groupKeys.forEach((groupKey) => {
        if (myCounts.value?.[groupKey]) {
            total += myCounts.value?.[groupKey] || 0;
        }
    })

    return total;
}

const totalMainCounts = computed(() => {
    let total = 0;
    getters["mainChat/conversations"]?.data?.forEach((x) => {
        total += processSprint(x._id)
    })
    getters["mainChat/mainChatProjects"]?.data?.forEach((x) => {
        total += processSprint(x._id)
    })
    return total;
})

</script>

<style scoped>
.notification-tick {
    right: 6px;
    top: 6px;
    left: unset;
    z-index: 1;
}

.eoffice-action-dot {
    position: absolute;
    top: 1px;
    right: 1px;
    width: 8px;
    height: 8px;
    border: 1px solid #fff;
    border-radius: 50%;
    background: #ef4444;
    z-index: 2;
}

.main-sidebar-shell {
    flex: 0 0 auto;
    min-width: max-content;
}

/* Sidebar chính */
.sidebar-wrapper {
    width: 48px;
    background: linear-gradient(180deg, var(--Blue-500, #016CD7) 0%, var(--Blue-900, #002D5A) 100%);
    border-right: 1px solid #eee;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: space-between;
    padding-top: 10px;
    transition: width 0.3s ease;
    height: calc(100vh - 80px);
    overflow-y: auto;
    overflow-x: hidden;
    margin: 8px;
    border-radius: 8px;
}

.notes-sidebar-panel {
    padding: 12px 12px 16px;
    background: #f8fafc;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
}

.notes-sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.sidebar-close {
    display: flex;
    width: 28px;
    height: 28px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    aspect-ratio: 1/1;
    border-radius: var(--s, 8px);
    border: 1px solid var(--Mobile-search_bar, #F1F5F9);
    background: var(--Mobile-bg_icon, #FAFAFA);
}
.expand-bubble {
    margin: 8px 8px 8px 0;
    height: calc(100vh - 80px);
    overflow: hidden;
    max-width: 20vw;
    width: 100%;
    flex: 0 0 20vw;
    overflow-y: auto;
    overflow-x: hidden;
    scrollbar-width: none;
}
.note-categories {
    display: grid;
    gap: 8px;
    margin-bottom: 16px;
}

.note-categories button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 8px 10px;
    border-radius: 10px;
    border: 1px solid transparent;
    background: #ffffff;
    color: #334155;
    font-size: 12px;
    cursor: pointer;
}

.note-categories button.active {
    border-color: #cbd5e1;
    background: #eff6ff;
}

.note-item {
    display: block;
    width: 100%;
    padding: 10px 12px;
    border: none;
    background: #ffffff;
    border-radius: 10px;
    text-align: left;
    cursor: pointer;
    color: #334155;
    margin-bottom: 8px;
}

.note-item:hover {
    background: #edf2ff;
}

.recent-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
}



.recent-note-title {
    font-size: 13px;
    color: #0f172a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.recent-note-date {
    font-size: 11px;
    color: #64748b;
    margin-left: 8px;
}

.notes-bubble-overlay {
    position: fixed;
    top: 86px;
    left: 74px;
    z-index: 1200;
    width: 320px;
    max-height: calc(100vh - 120px);
    overflow: hidden;
    background: transparent;
    padding: 0;
}

.notes-bubble-card {
    width: 100%;
    background: #ffffff;
    border-radius: 20px;
    border: 1px solid rgba(148, 163, 184, 0.18);
    overflow: hidden;
}

.notes-bubble-card .notes-sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 18px 20px;
    border-bottom: 1px solid #eef2ff;
}

.notes-bubble-card .sidebar-close {
    background: #f1f5f9;
    border: none;
    width: 34px;
    height: 34px;
    border-radius: 12px;
    color: #334155;
    font-size: 18px;
    cursor: pointer;
}

.notes-bubble-card .sidebar-title {
    font-weight: 700;
    font-size: 16px;
    color: #0f172a;
}

.note-categories {
    display: grid;
    gap: 10px;
    padding: 16px 20px;
}

.note-categories button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 12px 14px;
    border-radius: 14px;
    border: 1px solid transparent;
    background: #f8fafc;
    color: #0f172a;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
}

.note-categories button.active {
    background: #eff6ff;
    border-color: #dbeafe;
}

.notes-bubble-card .sidebar-panel {
    background: #ffffff;
    border-radius: 18px;
    padding: 16px 18px;
    margin-top: 14px;
}

.sidebar-panel--scroll {
    max-height: 320px;
    overflow-y: auto;
}

.panel-title {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: #334155;
    margin-bottom: 12px;
}


.panel-empty {
    padding: 18px;
    border-radius: 14px;
    background: #f1f5f9;
    color: #64748b;
    font-size: 13px;
}

.note-item {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 12px 14px;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    background: #f8fafc;
    color: #0f172a;
    text-align: left;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
}

.note-item:hover {
    background: #eef2ff;
    border-color: #dbeafe;
}

.recent-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: grid;
    gap: 8px;
}




.recent-note-title {
    font-size: 13px;
    color: #0f172a;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
}

.recent-note-date {
    font-size: 11px;
    color: #64748b;
    margin-left: 10px;
}

.notes-bubble-card .panel-title {
    font-size: 12px;
    font-weight: 700;
    color: #334155;
    text-transform: uppercase;
    margin-bottom: 10px;
}

/* Khi mở rộng */
.sidebar-wrapper.open {
    width: 200px;
}

.sidebar-wrapper.open .menu-item {
    justify-content: flex-start !important;
}

/* Toggle button */
.toggle-btn {
    background: none;
    border: none;
    cursor: pointer;
    padding: 5px;
}
.menu-divider {
    height: 1px;
    background: rgba(255, 255, 255, 0.12);
}
.toggle-btn img {
    width: 24px;
    height: 24px;
}

/* Danh sách menu */
.sidebar-icons {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    flex: 0 1 auto;
}

/* Item menu */
.sidebar-icons li {
    width: 100%;
}

/* Menu item */
.menu-item {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    height: 32px;
    text-decoration: none;
    color: #333;
    overflow: hidden;
    cursor: pointer;
}

.bg-full {
    position: absolute;
    top: 0;
    height: 32px;
    border-radius: 6px;
    z-index: 0;
    transition: all 0.25s ease;

    left: 50%;
    width: 32px;
    /* chỉ bằng icon */
    transform: translateX(-50%);
    background: transparent;
}

.menu-item.open:hover .bg-full {
    background: #f8faff;
    left: 6px;
    width: calc(100% - 12px);
    transform: none;
}

.menu-item.open.active .bg-full {
    left: 6px;
    width: calc(100% - 12px);
    transform: none;
    background: #E6F0FB;
}

/* Vùng chứa icon – cố định width */
.icon-wrapper {
    width: 32px;
    height: 32px;
    position: relative;
    flex-shrink: 0;
    z-index: 1;
}

.icon-wrapper[data-label]:hover::after {
    content: attr(data-label);
    position: absolute;
    left: 100%;
    /* hiển thị bên phải icon */
    top: 50%;
    transform: translateY(-50%);
    background: #1e1e1e;
    color: #fff;
    padding: 6px 10px;
    border-radius: 6px;
    white-space: nowrap;
    z-index: 9999;
    font-size: 13px;
    pointer-events: none;

    opacity: 1;
    transition: opacity 0.2s ease;
}

/* Background */
.icon-bg {
    position: absolute;
    inset: 0;
    background: transparent;
    border-radius: 6px;
    transition: background 0.25s ease;
}

.menu-icon {
    width: 22px;
    height: 22px;
    fill: currentColor;
    z-index: 1;
    position: relative;
}

.menu-item.active .menu-icon,
.menu-item:hover .menu-icon {
    color: #014D99;
}

/* Hover */
.menu-item:hover .icon-bg {
    background: #f8faff;
}

/* Active */
.menu-item.active .icon-bg {
    background: #E6F0FB;
}

.menu-content {
    position: relative;
    z-index: 1;
    /* nằm trên .bg-full */
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 6px;
}

.menu-item:hover,
.menu-item.active {
    color: #014D99;
}


/* Khi mở sidebar */
.sidebar-wrapper.open .menu-item {
    /* KHÔNG justify-center nữa */
    justify-content: flex-start;
}

.bottom-menu {
    /* margin-top: auto; */
    list-style: none;
    padding: 0;
    margin: 0 0 10px 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 10px;
}

/* .bottom-menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
} */
</style>
